/** Display helpers for employee contact (supports legacy + new shape). */

export function officialEmail(contact) {
  if (!contact) return "";
  return contact.official_email || contact.email || "";
}

export function personalEmail(contact) {
  if (!contact) return "";
  return contact.personal_email || "";
}

export function formatAddressBlock(addr) {
  if (!addr) return "";
  return [
    addr.address_line1,
    addr.address_line2,
    addr.city,
    addr.state,
    addr.country,
    addr.pincode,
  ]
    .filter(Boolean)
    .join(", ");
}

export function communicationAddress(contact) {
  if (!contact) return "";
  if (contact.communication_address) {
    return formatAddressBlock(contact.communication_address);
  }
  return formatAddressBlock({
    address_line1: contact.address_line1,
    address_line2: contact.address_line2,
    city: contact.city,
    state: contact.state,
    country: contact.country,
    pincode: contact.pincode,
  });
}

export function permanentAddress(contact) {
  if (!contact) return "";
  if (contact.permanent_same_as_communication) {
    return communicationAddress(contact);
  }
  if (contact.permanent_address) {
    return formatAddressBlock(contact.permanent_address);
  }
  return "";
}
